function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    ",
        ";\n    ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        &:active:enabled {\n            transform: none;\n        }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                border-bottom-left-radius: 0;\n                border-top-left-radius: 0;\n                ",
        ";\n            "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                border-bottom-right-radius: 0;\n                border-top-right-radius: 0;\n                ",
        ";\n            "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n        height: ",
        ";\n        width: ",
        ";\n\n        svg {\n            width: ",
        ";\n            height: ",
        ";\n        }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n            background: none;\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        "\n        ",
        ";\n        ",
        ";\n        ",
        "\n        ",
        "\n\n        box-sizing: border-box;\n        display: grid;\n        place-items: center;\n        flex-shrink: 0;\n        padding: 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { UnhandledError } from "@internal/errors";
import { rem } from "polished";
import React from "react";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import { rounded } from "../css/rounded";
import { baseButtonStyles, buttonTransitionStyles, twButtonBase, twButtonTransition } from "./Button";
var _btnSize;
export var twIconButton = function(props) {
    return "".concat(twIconButtonBase(props), " ").concat(twIconButtonSize((_btnSize = props.btnSize) !== null && _btnSize !== void 0 ? _btnSize : 48), " ").concat(twIconButtonEdge(props.edge));
};
var IconButton = /*#__PURE__*/ forwardRef(function(props, ref) {
    var _type = props.type, type = _type === void 0 ? "button" : _type, rest = _objectWithoutProperties(props, [
        "type"
    ]);
    return /*#__PURE__*/ _jsx(IconButtonStyled, _objectSpread({
        ref: ref,
        type: type
    }, rest));
});
export { IconButton };
var _btnSize1;
var IconButtonStyled = styled.button.withConfig({
    componentId: "sc-896e5e1b-0"
})(_templateObject(), baseIconButtonStyles, function(props) {
    return iconButtonSizeStyles((_btnSize1 = props.btnSize) !== null && _btnSize1 !== void 0 ? _btnSize1 : 48);
}, function(props) {
    return iconButtonEdgeStyles(props.edge);
});
export var twIconButtonEdge = function(edge) {
    switch(edge){
        case "end":
            return "rounded-bl-none rounded-tl-none active:transform-none";
        case "start":
            return "rounded-br-none rounded-tr-none active:transform-none";
        default:
            return null;
    }
};
export function iconButtonEdgeStyles(edge) {
    var disableActiveTransition = css(_templateObject1());
    switch(edge){
        case "end":
            return css(_templateObject2(), disableActiveTransition);
        case "start":
            return css(_templateObject3(), disableActiveTransition);
        default:
            return null;
    }
}
var _obj;
var sizeClasses = (_obj = {}, _defineProperty(_obj, 48, "h-12 w-12 [&_svg]:h-5 [&_svg]:w-5"), _defineProperty(_obj, 34, "h-[34px] w-[34px] [&_svg]:h-[14px] [&_svg]:w-[14px]"), _obj);
export var twIconButtonSize = function(size) {
    return sizeClasses[size];
};
export function iconButtonSizeStyles(size) {
    return css(_templateObject4(), rem(size), rem(size), rem(5 / 12 * size), rem(5 / 12 * size));
}
export var twIconButtonBase = function(props) {
    var _variant = props.variant, variant = _variant === void 0 ? "primary" : _variant, _shape = props.shape, shape = _shape === void 0 ? "circle" : _shape, blend = props.blend, btnSize = props.btnSize, hover = props.hover, active = props.active;
    return "".concat(twButtonTransition(), " ").concat(twButtonBase({
        variant: variant,
        blend: blend,
        hover: hover,
        active: active
    }), " ").concat(twIconButtonShape({
        shape: shape,
        btnSize: btnSize
    }), " grid place-items-center shrink-0 p-0");
};
export function baseIconButtonStyles(props) {
    var _variant, _shape;
    return css(_templateObject6(), buttonTransitionStyles, baseButtonStyles({
        variant: (_variant = props.variant) !== null && _variant !== void 0 ? _variant : "primary"
    }), iconButtonShapeStyles({
        shape: (_shape = props.shape) !== null && _shape !== void 0 ? _shape : "circle",
        btnSize: props.btnSize
    }), buttonTransitionStyles, props.blend && css(_templateObject5()));
}
export var twIconButtonShape = function(param) {
    var shape = param.shape, _btnSize2 = param.btnSize, btnSize = _btnSize2 === void 0 ? 48 : _btnSize2;
    switch(shape){
        case "square":
            return btnSize === 48 ? "rounded-[12px]" : "rounded-[8px]";
        case "circle":
            return "rounded-full";
        default:
            throw new UnhandledError(shape);
    }
};
export function iconButtonShapeStyles(param) {
    var shape = param.shape, btnSize = param.btnSize;
    switch(shape){
        case "square":
            return rounded(btnSize === 34 ? 8 : 12);
        case "circle":
            return rounded(btnSize === 34 ? 17 : 24);
        default:
            throw new UnhandledError(shape);
    }
}
